export function fetchAllStates() {
  return window.axios
    .get("/document/states/all")
    .then((response) => response.data);
}
